import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,load} from '../utils.js'
import UniTable from '../cmp/UniTable.js'

function RepObjEntries({data=undefined,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    let table=undefined
    if(wndData) table=wndData.table
    const setWndData=actions.setWndData
    const context=useContext(dataContext)
    const getData=context.getData
    const msg=context.msg

    const cols=[
        {caption:'icon',minWidth:'24',dataId:'run',sortable:false},
        {caption:localestr('Дебет'),minWidth:'55',maxWidth:'60',dataId:'acc_d',sortable:true},
        {caption:localestr('Аналітика 1'),minWidth:'75',dataId:'an1_d',sortable:true},
        {caption:localestr('Аналітика 2'),minWidth:'75',dataId:'an2_d',sortable:true},
        {caption:localestr('Аналітика 3'),minWidth:'75',dataId:'an3_d',sortable:true},
        {caption:localestr('Кредит'),minWidth:'55',maxWidth:'60',dataId:'acc_c',sortable:true},
        {caption:localestr('Аналітика 1'),minWidth:'75',dataId:'an1_c',sortable:true},
        {caption:localestr('Аналітика 2'),minWidth:'75',dataId:'an2_c',sortable:true},
        {caption:localestr('Аналітика 3'),minWidth:'75',dataId:'an3_c',sortable:true},
        {caption:localestr('Кіл-сть'),minWidth:'60',maxWidth:'65',dataId:'sum_qtt',sortable:true},
        {caption:localestr('Сума'),minWidth:'65',maxWidth:'70',dataId:'sum',sortable:true},
    ]

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setWndData({...wndData,table:d.data})
        } else {
            load('action=repObjEntries&data='+JSON.stringify({id:wndData.object.id,type:wndData.object.type}),(dt)=>{loadData(dt)})
        }

    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (table) list=table.map((item,idx)=>{
            const newItem={...item,uid:idx+1}
            if(item.an1_d.type){
                let arr=getData(item.an1_d.type,true,null,update) //dataType,loading=true,pid=null,callback
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an1_d.id)
                    if(it) newItem.an1_d=it
                }
            }
            if(item.an2_d.type){
                let arr=getData(item.an2_d.type,true,null,update)
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an2_d.id)
                    if(it) newItem.an2_d=it
                }
            }
            if(item.an3_d.type){
                let arr=getData(item.an3_d.type,true,null,update)
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an3_d.id)
                    if(it) newItem.an3_d=it
                }
            }
            if(item.an1_c.type){
                let arr=getData(item.an1_c.type,true,null,update) 
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an1_c.id)
                    if(it) newItem.an1_c=it
                }
            }
            if(item.an2_c.type){
                let arr=getData(item.an2_c.type,true,null,update)
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an2_c.id)
                    if(it) newItem.an2_c=it
                }
            }
            if(item.an3_c.type){
                let arr=getData(item.an3_c.type,true,null,update)
                if(arr){
                    const it=arr.find(el=>parseInt(el.id)===item.an3_c.id)
                    if(it) newItem.an3_c=it
                }
            }
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol({...newItem})
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col==='date') {
                vala=(a[col])
                valb=(b[col])
            } else if(col==='sum') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }
    
    const setCol=(currentCol)=>{
        setWndData({...wndData,currentCol})
    }

    const update=()=>{
        if (typeof table === 'undefined') loadData()
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('date','asc',undefined)
    }

    useEffect(() => {
        update()
        // eslint-disable-next-line 
    },[table,context.data])



    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting

    return(
    <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={wndData.currentCol} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={()=>{}} keyHandle={()=>{}}/>
    )
}
export default RepObjEntries